var jQuery = require("jquery")

global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

export const rails_ujs = require("@rails/ujs")
rails_ujs.start()
global.Rails = Rails;

require("turbolinks").start()
require("@rails/activestorage").start()

import "bootstrap"
import "../stylesheets/public_website.scss"

// Membership Tiers Pricing Toggle
$(document).on("turbolinks:load", () => {
  const pricingToggle = document.getElementById('pricingToggle');
  const monthlyOption = document.getElementById('monthlyOption');
  const yearlyOption = document.getElementById('yearlyOption');
  const priceDisplays = document.querySelectorAll('.price-display');
  const savingsBadges = document.querySelectorAll('.savings-badge');
  
  if (pricingToggle && monthlyOption && yearlyOption) {
    function togglePricing(isYearly) {
      if (isYearly) {
        pricingToggle.classList.add('yearly');
        monthlyOption.classList.remove('active');
        monthlyOption.classList.add('inactive');
        yearlyOption.classList.remove('inactive');
        yearlyOption.classList.add('active');
        
        priceDisplays.forEach(function(display) {
          display.textContent = display.getAttribute('data-yearly');
        });
        
        // Update subscribe forms to use yearly price ids
        document.querySelectorAll('form.plan-subscribe').forEach(function(form) {
          var yearlyId = form.dataset.yearly;
          var input = form.querySelector('input[name="price_id"]');
          if (input && yearlyId) { input.value = yearlyId; }
        });

        // Show savings badges with animation (excluding free plan)
        setTimeout(function() {
          savingsBadges.forEach(function(badge) {
            if (badge.getAttribute('data-savings') !== '0') {
              badge.classList.add('show');
            }
          });
        }, 150);
        
      } else {
        pricingToggle.classList.remove('yearly');
        yearlyOption.classList.remove('active');
        yearlyOption.classList.add('inactive');
        monthlyOption.classList.remove('inactive');
        monthlyOption.classList.add('active');
        
        priceDisplays.forEach(function(display) {
          display.textContent = display.getAttribute('data-monthly');
        });

        // Update subscribe forms to use monthly price ids
        document.querySelectorAll('form.plan-subscribe').forEach(function(form) {
          var monthlyId = form.dataset.monthly;
          var input = form.querySelector('input[name="price_id"]');
          if (input && monthlyId) { input.value = monthlyId; }
        });
        
        // Hide savings badges
        savingsBadges.forEach(function(badge) {
          badge.classList.remove('show');
        });
      }
    }
    
    monthlyOption.addEventListener('click', function() {
      togglePricing(false);
    });
    
    yearlyOption.addEventListener('click', function() {
      togglePricing(true);
    });

    // Ensure forms reflect initial state (default monthly)
    togglePricing(false);
  }
});
